import { useProfilePreview } from "PFApp/use_profile_preview";
import { ProfileCard, ProfileCardProps } from "PFComponents/profile_card/profile_card";
import { useMyAccountInfo } from "PFCore/hooks/queries/account/use_my_account_info";
import { IconName } from "PFTheme/graphics/icons";
import { MatchedProfile, ProfileMinimized } from "PFTypes";
import { SyntheticEvent, useMemo } from "react";

import { useProfileChatIcon } from "./use_profile_chat_icon";

type ProfileCardConnectedProps = Omit<
  ProfileCardProps,
  "customTypes" | "handleClick" | "icon" | "handleIconClick" | "isUnbiasedMode"
> & {
  profileResponse: MatchedProfile;
  withChat?: boolean;
  onClick?: () => void;
  icon?: IconName;
  handleIconClick?: (e: SyntheticEvent) => void;
  isUnbiasedMode?: boolean;
};

/**
 * @deprecated Use application\components\profile_card
 */
export const ProfileCardConnected = (props: ProfileCardConnectedProps) => {
  const {
    data: { custom_types: customTypes }
  } = useMyAccountInfo();

  const { showPreview } = useProfilePreview();

  const { profileResponse, withChat } = props;

  const { icon, handleClick: handleChatClick } = useProfileChatIcon(
    profileResponse as unknown as ProfileMinimized
  );

  const onClick = () => {
    if (props.onClick) {
      onClick();
    }
    const { profile } = props.profileResponse;
    if (profile) {
      showPreview({ id: profile.id, profile });
    }
  };

  const handleIconClick = useMemo(
    () => props.handleIconClick || (withChat ? handleChatClick : undefined),
    [handleChatClick, withChat, props.handleIconClick]
  );

  const finalIcon = props.icon || (withChat ? icon : undefined);

  return (
    <ProfileCard
      {...(props as ProfileCardProps)}
      customTypes={customTypes}
      handleClick={onClick}
      icon={finalIcon}
      handleIconClick={handleIconClick}
    />
  );
};
